module.exports = __webpack_public_path__ + "img/60ne.16308800.svg";